import { render, staticRenderFns } from "./toTransfer.vue?vue&type=template&id=2bc2286a"
import script from "./toTransfer.vue?vue&type=script&lang=js"
export * from "./toTransfer.vue?vue&type=script&lang=js"
import style0 from "./toTransfer.vue?vue&type=style&index=0&id=2bc2286a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc2286a')) {
      api.createRecord('2bc2286a', component.options)
    } else {
      api.reload('2bc2286a', component.options)
    }
    module.hot.accept("./toTransfer.vue?vue&type=template&id=2bc2286a", function () {
      api.rerender('2bc2286a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/baseInfo/printSetting/faceBillBalanceSearch/components/toTransfer.vue"
export default component.exports